export const queryKeys = {
    userInfo: ['userInfo'] as const,
    department: ['department'] as const,
    group: ['group'] as const,
    branch: ['branch'] as const,
    person: ['person'] as const,
    userMessage: ['userMessage'] as const,
    vacationCalendar: ['vacationCalendar'] as const,
    vacationAnnual: ['vacationAnnual'] as const,
    vacationAnnualDetail: ['vacationAnnualDetail'] as const,
    vacationApproval: ['vacationApproval'] as const,
    vacationApprovalDetail: ['vacationApprovalDetail'] as const,
    holidays: ['holidays'] as const,
}